import { Utils } from './utils';

// ハンバーガータイムラインを保持する変数
let hamburgerTweenTimeline = null;

// -----------------------------------------------
// スクロールアニメーション定義
// -----------------------------------------------
// フェードイン
const fadeIn = {
  set: { opacity: 0 },
  to: { opacity: 1, duration: 1.4, delay: 0, ease: 'power2.easeIn' },
};
// ふわっと上がる
const fadeInUp = {
  // set: { x: '-80', opacity: 0 },
  // to: { x: '0', opacity: 1, duration: 1.0, delay: 0, ease: 'power1.easeInOut' },
  set: { y: '60', opacity: 0 },
  to: { y: '0', opacity: 1, duration: 0.6, delay: 0, ease: 'power1.easeOut' },
};
// アニメーション定義
const animationConfig = {
  fadeIn,
  fadeInUp,
};

// 画面内にある要素かどうかを判断するヘルパー関数
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  // ウィンドウの高さと幅を取得
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  // 要素の一部が画面内にあるかどうかを判断
  return (
    rect.bottom >= 0 && // 要素の下端がビューポートの上端より下にある
    rect.right >= 0 && // 要素の右端がビューポートの左端より右にある
    rect.top <= windowHeight && // 要素の上端がビューポートの下端より上にある
    rect.left <= windowWidth // 要素の左端がビューポートの右端より左にある
  );
}

// -----------------------------------------------
// スクロールアニメーション初期化
// -----------------------------------------------
function initScrollAnimation(selector, options = { once: true }) {
  const targets = document.querySelectorAll(selector);

  targets.forEach((el) => {
    const anime = JSON.parse(JSON.stringify(animationConfig[el.dataset.anime]));

    // -------------------------
    // set（初期設定）
    // -------------------------
    // setが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.set)) {
      anime.set = new Array(anime.set);
    }
    anime.set.forEach((set) => {
      let target = el;
      if (set.target) {
        target = set.target;
        delete set.target;
      }
      gsap.set(target, set);
    });

    // -------------------------
    // to（アニメーション）
    // -------------------------
    // toが配列でない場合は、配列に変換する
    if (!Array.isArray(anime.to)) {
      anime.to = new Array(anime.to);
    }

    // scrollTrigger設定
    let st = {};
    if (!isInViewport(el)) {
      // 対象要素が画面外の場合はを設定
      st = { scrollTrigger: { trigger: el, start: 'top 90%', markers: false } };

      if (el.dataset.start) {
        st.scrollTrigger.start = el.dataset.start;
      }
      // st = { scrollTrigger: { trigger: el, markers: true, start: 'top+=50 bottom' } };
      if (!options.once) {
        st.scrollTrigger.toggleActions = 'play reset play reset';
      }
    }

    const tl = gsap.timeline(st);
    anime.to.forEach((to, index) => {
      // 配列の先頭要素だけ、data属性から渡された時間を設定する
      if (index === 0) {
        // data属性 > 定数 の優先度でセットする。全てなしならば0とする
        to.duration = el.dataset.duration || to.duration || 0;
        to.delay = el.dataset.delay || to.delay || 0;
      }

      let target = el;
      if (to.target) {
        target = to.target;
        delete to.target;
      }
      if (to.position || to.position === 0) {
        const position = to.position;
        delete to.position;
        tl.to(target, to, position);
        console.log(position);
      } else {
        tl.to(target, to);
      }
    });
  });
}

// -----------------------------------------------
// ハンバーガーを開閉する
// -----------------------------------------------
function toggleHamburger(target, hamburgerTweenTimeline) {
  const isOpen = target.classList.toggle('is-open');

  // 通常のheaderハンバーガーの処理
  const header = target.closest('.js-header');
  if (header) {
    const drawer = header.querySelector('.js-drawer');
    header.classList.toggle('is-open');
    drawer.classList.toggle('is-open');

    if (isOpen) {
      disableScroll();
      hamburgerTweenTimeline.play(0);
    } else {
      enableScroll();
      hamburgerTweenTimeline.reverse();
    }
  }

  // FVハンバーガーの処理（既存のheader.phpと同じ動きにする）
  const fvHeader = target.closest('.fv-header');
  if (fvHeader) {
    const fvDrawer = fvHeader.querySelector('.js-drawer');
    if (fvDrawer) {
      fvDrawer.classList.toggle('is-open');
      
      if (isOpen) {
        disableScroll();
        hamburgerTweenTimeline.play(0);
      } else {
        enableScroll();
        hamburgerTweenTimeline.reverse();
      }
    }
  }
}

// -----------------------------------------------
// ハンバーガーを強制的に閉じる
// -----------------------------------------------
export function forceCloseHamburger() {
  // 開いているドロワーをチェック
  const openDrawer = document.querySelector('.js-drawer.is-open');
  if (!openDrawer) {
    return;
  }

  // 開いているドロワーに対応する正しいハンバーガーボタンを見つける
  let hamburgerButton = null;
  
  // ドロワーの親要素をチェック
  const fvHeaderDrawer = openDrawer.closest('.fv-header__drawer');
  const headerDrawer = openDrawer.closest('.header__drawer');
  
  if (fvHeaderDrawer) {
    // FVヘッダーのドロワーの場合
    const fvHeader = fvHeaderDrawer.closest('.fv-header');
    if (fvHeader) {
      hamburgerButton = fvHeader.querySelector('.js-hamburger');
    }
  } else if (headerDrawer) {
    // 通常のヘッダーのドロワーの場合
    const header = headerDrawer.closest('.js-header');
    if (header) {
      hamburgerButton = header.querySelector('.js-hamburger');
    }
  }

  // ハンバーガーボタンが見つからない場合は何もしない
  if (!hamburgerButton) {
    return;
  }

  // ハンバーガーボタンをクリックして閉じる
  // （既存のtoggleHamburger処理を利用）
  hamburgerButton.click();
}

// -----------------------------------------------
// ハンバーガーアニメーションタイムライン生成
// -----------------------------------------------
function createHamburgerTweenTimeline(target) {
  const line1 = target.querySelector('.hamburger__line span:nth-child(1)');
  const line2 = target.querySelector('.hamburger__line span:nth-child(2)');
  const line3 = target.querySelector('.hamburger__line span:nth-child(3)');
  const tl = gsap.timeline({ paused: true });
  const lineMarginPc = 10;
  const lineMarginSp = 8;

  // 3本線の場合（hamburger--three-lineクラスがある場合）
  if (line3 && target.closest('.hamburger--three-line')) {
    // 中央線の位置を取得（2本目の線の位置）
    const centerY = Utils.isPc() ? lineMarginPc : lineMarginSp;
    
    // 1本目と3本目を中央（2本目の位置）に移動してから×マークに変化
    tl.to(line1, { y: centerY, duration: 0.2, ease: 'power1.inOut' }, 0); // 1本目を中央に移動
    tl.to(line3, { y: -centerY, duration: 0.2, ease: 'power1.inOut' }, 0); // 3本目を中央に移動
    tl.to(line2, { opacity: 0, duration: 0.15, ease: 'linear' }, 0.2); // 中央線を非表示
    tl.to(line1, { rotate: '-45deg', duration: 0.2, ease: 'power1.inOut' }, 0.3); // 上線を回転
    tl.to(line3, { rotate: '45deg', duration: 0.2, ease: 'power1.inOut' }, 0.3); // 下線を回転
  } else {
    // 既存の2本線アニメーション
    const y1 = Utils.isPc() ? lineMarginPc / 2 : lineMarginSp / 2;

    tl.to(line1, { y: y1, duration: 0.2, ease: 'linear' }, 0);
    tl.to(line2, { y: y1 * -1, duration: 0.2, ease: 'linear' }, 0);
    tl.to(line1, { rotate: '-45deg', duration: 0.2, ease: 'power1.inOut' }, 0.2);
    tl.to(line2, { rotate: '45deg', duration: 0.2, ease: 'power1.inOut' }, 0.2);
  }
  
  return tl;
}

// -----------------------------------------------
// スクロール無効
// -----------------------------------------------
function disableScroll() {
  document.querySelector('body').classList.add('disable-scroll');
  document.addEventListener('touchmove', preventDefaultEvent, { passive: false });
}

// -----------------------------------------------
// スクロール有効
// -----------------------------------------------
function enableScroll() {
  document.querySelector('body').classList.remove('disable-scroll');
  document.removeEventListener('touchmove', preventDefaultEvent, { passive: false });
}

// -----------------------------------------------
// スクロール無効用のイベント防止
// -----------------------------------------------
function preventDefaultEvent(event) {
  if (event.target.closest('.drawer__content')) {
    return;
  }
  event.preventDefault();
}



//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  Utils.switchViewport(376, 390);

  //-------------------------------------------
  // イベント
  //-------------------------------------------
  // ハンバーガークリック
  if (document.querySelector('.js-hamburger')) {
    document.querySelectorAll('.js-hamburger').forEach((el) => {
      // 正しいハンバーガー要素を取得してタイムライン作成
      const hamburgerElement = el.querySelector('.hamburger');
      const localTimeline = createHamburgerTweenTimeline(hamburgerElement || el);
      
      el.addEventListener('click', (event) => {
        // 現在のタイムラインを保存
        hamburgerTweenTimeline = localTimeline;
        
        // クリックされた要素から正しいハンバーガー要素を取得
        const clickedHamburgerElement = event.currentTarget.querySelector('.hamburger') || event.currentTarget.closest('.hamburger');
        toggleHamburger(clickedHamburgerElement || event.currentTarget, localTimeline);
      });
    });
  }



  // スクロールアニメーション
  if (document.querySelector('.js-scroll-anime')) {
    initScrollAnimation('.js-scroll-anime');
  }
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
window.addEventListener('load', () => {
  setTimeout(function () {
    // ループギャラリー
    if (document.querySelector('.js-loop-contents')) {
      document.querySelectorAll('.js-loop-contents').forEach(function (element) {
        // PC用とモバイル用のdurationを取得
        const baseDuration = parseInt(element.dataset.duration) || 100; // デフォルト100
        const mobileDuration = parseInt(element.dataset.durationMobile); // モバイル用（設定がなければundefined）

        // 最終的なdurationを決定（モバイルの場合はdata-duration-mobileを優先）
        const duration = Utils.isMobile() && mobileDuration ? mobileDuration : baseDuration;

        // 他のデータ属性も取得
        const minItems = parseInt(element.dataset.minItems) || 9; // デフォルト9
        const isReverse = element.dataset.reverse !== undefined; // data-reverse属性が指定されている場合はtrue

        // ul要素を取得
        const originalUl = element.querySelector('ul');
        let totalLiCount = originalUl.querySelectorAll('li').length;

        // ul要素とその子要素を必ず一つ複製
        const clonedUl = originalUl.cloneNode(true);
        originalUl.parentNode.appendChild(clonedUl);

        // さらに、liの数が合計minItems以上かつ偶数になるまで複製を追加
        totalLiCount += clonedUl.querySelectorAll('li').length;
        while (totalLiCount % 2 !== 0 || totalLiCount < minItems) {
          const additionalClonedUl = originalUl.cloneNode(true);
          originalUl.parentNode.appendChild(additionalClonedUl);
          totalLiCount += additionalClonedUl.querySelectorAll('li').length;
        }

        // ul要素の数が偶数になるように調整
        let ulCount = element.querySelectorAll('ul').length;
        if (ulCount % 2 !== 0) {
          const additionalClonedUl = originalUl.cloneNode(true);
          originalUl.parentNode.appendChild(additionalClonedUl);
          ulCount++;
        }

        // アニメーションの方向を設定
        const startX = isReverse ? '-50%' : '0%';
        const endX = isReverse ? '0%' : '-50%';

        // アニメーションの持続時間を計算
        const baseLiCount = 40; // 基準となるliの数
        const duration2 = (totalLiCount / baseLiCount) * duration;

        // gsapアニメーションの設定
        gsap.fromTo(
          element,
          { x: startX },
          {
            x: endX,
            duration: duration2, // アニメーションの持続時間を秒単位で設定
            ease: 'linear', // 一定速度で移動
            repeat: -1, // 無限に繰り返す
          }
        );
      });
    }

  }, 100); // 確実に最後に処理するよう遅延を入れる
});
